(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const headerIcons = document.querySelector('.header .header__icons');
  const narrowHeaderMq = window.matchMedia('(width <= 74.99em)');
  const headerIconTabSuppressSelector =
    '.header__localization a, .header__localization button, .header__icon--account, .header__icon--search, .header__icon--cart';

  const syncHeaderIconFocusability = () => {
    if (!headerIcons) {
      return;
    }

    const suppressOnNarrow = narrowHeaderMq.matches;

    for (const el of headerIcons.querySelectorAll(headerIconTabSuppressSelector)) {
      if (suppressOnNarrow) {
        el.setAttribute('tabindex', '-1');
      } else {
        el.removeAttribute('tabindex');
      }
    }
  };

  syncHeaderIconFocusability();
  narrowHeaderMq.addEventListener('change', syncHeaderIconFocusability);

  const headerLocalizationSink = document.querySelector('.header .header__localization');
  const menuDrawerLocalizationSlot = document.getElementById('MenuDrawerLocalizationSlot');

  const clearForcedTabindex = (root) => {
    if (!root) {
      return;
    }

    for (const el of root.querySelectorAll('a, button')) {
      if (el.getAttribute('tabindex') === '-1') {
        el.removeAttribute('tabindex');
      }
    }
  };

  const syncMenuDrawerFooterPlacement = () => {
    const narrow = narrowHeaderMq.matches;

    if (headerLocalizationSink && menuDrawerLocalizationSlot) {
      const locSource = narrow ? headerLocalizationSink : menuDrawerLocalizationSlot;
      const locTarget = narrow ? menuDrawerLocalizationSlot : headerLocalizationSink;

      if (locSource.firstChild) {
        while (locSource.firstChild) {
          locTarget.appendChild(locSource.firstChild);
        }

        clearForcedTabindex(locTarget);
      }
    }

    syncHeaderIconFocusability();
  };

  let menuDrawerFooterPlacementScheduled = false;

  const scheduleMenuDrawerFooterPlacement = () => {
    if (menuDrawerFooterPlacementScheduled) {
      return;
    }

    menuDrawerFooterPlacementScheduled = true;

    requestAnimationFrame(() => {
      menuDrawerFooterPlacementScheduled = false;
      syncMenuDrawerFooterPlacement();
    });
  };

  if (headerLocalizationSink && menuDrawerLocalizationSlot) {
    scheduleMenuDrawerFooterPlacement();
    narrowHeaderMq.addEventListener('change', scheduleMenuDrawerFooterPlacement);

    const menuDrawerFooterObserver = new MutationObserver(() => {
      scheduleMenuDrawerFooterPlacement();
    });

    menuDrawerFooterObserver.observe(headerLocalizationSink, { childList: true, subtree: true });
    menuDrawerFooterObserver.observe(menuDrawerLocalizationSlot, { childList: true, subtree: true });
  }

  const desktopSearchTrigger = document.getElementById('SearchTrigger');
  const searchModal = document.getElementById('SearchModal');

  if (desktopSearchTrigger && searchModal && !desktopSearchTrigger.dataset.searchInit) {
    desktopSearchTrigger.dataset.searchInit = 'true';

    desktopSearchTrigger.addEventListener('click', (event) => {
      event.preventDefault();

      if (window.dockManager && typeof window.dockManager.open === 'function') {
        window.dockManager.open(searchModal);
        return;
      }

      searchModal.classList.add('active');
      const fallbackInput = document.getElementById('Search-In-Modal');
      if (fallbackInput) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => fallbackInput.focus());
        });
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
